export default "__VITE_ASSET__1b1152f4__"